import * as React from 'react';

import { cn } from '@blockworks/ui/utils';

interface BenefitsListItemProps {
    children?: string | React.ReactNode;
    icon: JSX.Element;
    title: string;
    className?: string;
}

const BenefitsListItem = (props: BenefitsListItemProps) => {
    const { children, title, icon, className } = props;

    return (
        <div
            className={cn(
                'flex justify-start items-start self-stretch flex-grow-0 flex-shrink-0 relative gap-5',
                className,
            )}
        >
            <>{icon}</>
            <div className="flex flex-col justify-start items-start flex-grow relative gap-2">
                <p className="self-stretch flex-grow-0 flex-shrink-0 text-xl text-left text-[#110b29]">{title}</p>
                <p className="self-stretch flex-grow-0 flex-shrink-0 text-base text-left text-[#110b29]">
                    <>{children}</>
                </p>
            </div>
        </div>
    );
};

export default BenefitsListItem;
